export default "__VITE_ASSET__Dmcy_BjS__"